module.exports = __webpack_public_path__ + "6be4bfc9a081cb82910a1ac43eaee4c7.svg";